import React from 'react';
import s from './marker-address.module.css';

// `color`: the colour zone the order's pin is in, if any.
const MarkerAddress = ({ name, color, isOpen, onClick }) => {
	return (
		<div
			onClick={onClick}
			className={`hint hint--html hint--info hint--top ${s.container}`}
			style={{ position: 'absolute', transform: 'translate(-50%, -50%)' }}
			onDoubleClick={e => e.stopPropagation()}
			onMouseDown={e => e.stopPropagation()}
			onPointerDown={e => e.stopPropagation()}
			onTouchStart={e => e.stopPropagation()}
		>
			{!isOpen ? (
				<div
					className={s.containerClosed}
					style={color ? { backgroundColor: color, border: '2px solid #fff' } : undefined}
				/>
			) : (
				<div className={s.containerOpened}>{name}</div>
			)}
		</div>
	);
};

export default MarkerAddress;
